import React from 'react';
import BackToTopIcon from 'images/icons/share-outline.svg';
import { useWindowScrollPosition } from 'the-platform';
import './BackToTop.css';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

type BackToTopProps = {}
const BackToTop = () => {
  const snapHeight = 120
  const { y } = useWindowScrollPosition()

  return (
    <div id="back-to-top" className={`${y < snapHeight ? 'hidden' : ''} `}>
      <a className="top flex" id="top" href="#home">
        <img className="imgStyle" src={BackToTopIcon} alt='back to top'/>
      </a>
    </div>
  )
}

export default BackToTop